import {map, includes} from 'lodash';
import browserHistory from 'shared/history';
import {saveAttendance, saveAttendanceForSchoolYears} from 'shared/portfolio/actions/courses';
import {flashMessage, errorMessage} from 'shared/actions/notifications';
import {highSchoolYears} from 'shared/utils';
import {closeActivityModalPath} from '../utils';

export const savePerfectAttendance = (values) => (dispatch, getState) => {
  const {
    student: {
      highSchoolInfo: {graduationYear},
    },
  } = getState();
  const schoolYears = highSchoolYears(graduationYear);

  const attendance = {};

  schoolYears.forEach((schoolYear) => {
    let absences = 1;

    if (includes(values.attendance, schoolYear)) {
      absences = 0;
    }

    attendance[schoolYear] = absences;
  });

  return dispatch(saveAttendanceForSchoolYears(attendance))
    .then(() => {
      browserHistory.replace(closeActivityModalPath());
      dispatch(flashMessage('Nice! Your achievement has been saved.'));
    })
    .catch(() => {
      dispatch(errorMessage());
    });
};

export const removePerfectAttendance = () => (dispatch, getState) => {
  const {
    student: {
      highSchoolInfo: {graduationYear},
    },
  } = getState();
  const schoolYears = highSchoolYears(graduationYear);

  return Promise.all(map(schoolYears, (schoolYear) => dispatch(saveAttendance(schoolYear, 1))))
    .then(() => {
      dispatch(flashMessage('Perfect attendance successfully removed.'));
    })
    .catch(() => {
      dispatch(errorMessage());
    });
};
